
import * as React from "react";
import Translate from "../../common/functions/translate";

interface IProps {
}

interface IState {
    isLoading: boolean
}

class AccessoriesContainer extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false
        };
    }

    public render() {
        return (
            <div>
                <h1>{Translate("Accessories")}</h1>
            </div>
        )
    }
}

export default AccessoriesContainer